<template>
  <div class="policy-info">
    <div class="policy-info-box">
      <div class="policy-top">
        <small class="policyInfo">政策详情</small>
      </div>
      <div class="policy-bottom">
        <div class="policy-left">
          <div class="policy-slider">
            <h3 class="policy-t">{{ dataList.title }}</h3>
            <p class="policy-title-top">
              <small>查看次数：{{ dataList.readNum || 0 }}次阅读</small>
              <small>发布日期：{{ dataList.issueDate }}</small>
            </p>
            <div class="header-box">
              <div>
                <p>
                  <span>申报时段：</span>
                  <small>
                    {{
                      getDeclareState(
                        dataList.declareDateStart,
                        dataList.declareDateEnd,
                        dataList.declareDateType
                      )
                    }}
                  </small>
                </p>
                <p>
                  <span>政策来源：</span>
                  <small>
                    {{ dataList.source || "--" }}
                  </small>
                </p>
              </div>
              <div>
                <p>
                  <span>发布单位：</span
                  ><small>{{ dataList.issueDepartment }}</small>
                </p>
                <p>
                  <span>申报条件：</span
                  ><small>{{ dataList.acceptanceRequirments || "--" }}</small>
                </p>
              </div>
              <div>
                <p>
                  <span>支持力度：</span
                  ><small>
                    {{
                      dataList.supportStrength
                        ? dataList.supportStrength + "万元"
                        : "--"
                    }}
                  </small>
                </p>
                <p>
                  <span>支持方式：</span>
                  <small>
                    {{ dataList.supportWay || "--" }}
                  </small>
                </p>
              </div>
              <div>
                <p>
                  <span>联系人：</span>
                  <small>{{ dataList.cnname || "--" }}</small>
                </p>
                <p>
                  <span>联系方式：</span>
                  <small>
                    {{ dataList.administrativeOfficeNumber || "--" }}
                  </small>
                </p>
              </div>
              <div>
                <p>
                  <span>政策状态：</span>
                  <small>
                    {{
                      getDateState(
                        dataList.declareDateStart,
                        dataList.declareDateEnd,
                        dataList.declareDateType
                      )
                    }}
                  </small>
                </p>
                <p></p>
              </div>
              <div>
                <p>
                  <span>政策类别：</span
                  ><small class="policy-text">{{ dataList.type }}</small>
                </p>
              </div>
              <div>
                <p>
                  <span>支持产业：</span
                  ><small>{{ dataList.supportIndustry }}</small>
                </p>
              </div>
            </div>
            <div v-html="dataList.content" class="content"></div>
            <div class="materials-view" v-if="dataList.materials">
              <div>
                <p>附件下载：</p>
                <p
                  v-for="item in dataList.materials"
                  :key="item.uid"
                  class="file"
                >
                  <a :href="item.url" target="_blank" :download="item.name">
                    {{ item.name }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPolicyInfo, declareAble, attention } from "@/api/policy";
import { mapGetters } from "vuex";
import { decrypt, FunGetDateStr, encrypt } from "@/utils/index";
export default {
  data() {
    return {
      id: null,
      declareTitle: "立即申报",
      declareState: true,
      dataList: {
        type: "",
        supportIndustry: "",
        source: ""
      },
      followLoading: false,
      state: {
        no: "待领取",
        2: "审核中",
        3: "已通过",
        4: "退回修改"
      }
    };
  },
  computed: {
    ...mapGetters(["roleMenu"])
  },
  mounted() {
    let { id } = this.$route.query;
    if (id) {
      let code = decrypt(id);
      if (code) {
        this.id = code;
        this.getPolicy(code);
      }
    }
  },
  methods: {
    async attention() {
      let params = {
        policyId: this.id,
        type: this.dataList.isAttention == 0 ? 1 : 2
      };
      this.followLoading = true;
      let { data } = await attention(params);
      this.followLoading = false;
      if (data) {
        this.$message({
          message: params.type == 1 ? "已关注" : "已取消关注",
          type: "success"
        });
        this.dataList.isAttention = params.type == 2 ? 0 : 1;
      }
      console.log(data);
    },
    declare() {
      let { href } = this.$router.resolve({
        path: "/policy/policyDeclare",
        query: { id: encrypt(this.id) }
      });
      window.open(href);
    },
    getDeclareState(startTime, endTime, type) {
      if (type == 2) return "无限期";
      if (startTime && endTime) {
        return `${startTime}至${endTime}`;
      } else {
        return "--";
      }
    },
    /**政策已发布状态 */
    getDateState(startTime, endTime, type) {
      if (type == 2) return "申报中";
      const startTime1 = new Date(startTime).getTime();
      const endTime1 = new Date(endTime).getTime();
      let dateTime = new Date(FunGetDateStr(0)).getTime();
      if (!startTime && !endTime) {
        return "申报中";
      }
      if (dateTime < startTime1) {
        return "申报中";
      } else if (dateTime > endTime1) {
        return "申报结束";
      } else {
        return "申报中";
      }
    },
    async getdeclareAble(code) {
      // eslint-disable-next-line no-unused-vars
      let { data, msg } = await declareAble({ id: code });
      if (!data) {
        this.declareTitle = msg;
        this.declareState = true;
      } else {
        this.declareTitle = "立即申报";
        this.declareState = false;
      }
    },
    async getPolicy(id) {
      let { data } = await getPolicyInfo({ id: id });

      if (data.materials) {
        data.materials = JSON.parse(data.materials);
      }
      this.dataList = data;
      // if (data.ismsjx == "1") {
      //   this.getdeclareAble(this.id);
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.policy-info {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.policy-info-box {
  height: 0;
  flex: 1;
  border-radius: 5px;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 0 0 30px 0;
  & .policy-top {
    height: 60px;
    line-height: 60px;
    padding: 0 8%;
    & small {
      color: rgba(63, 114, 224, 1);
    }
  }
  & .policy-bottom {
    height: 0;
    flex: 1;
    display: flex;
    & .policy-left {
      width: 0;
      flex: 1;
      & .policy-t {
        text-align: center;
        font-size: 28px;
        color: #000000;
      }
    }
    & .policy-right-box {
      width: 378px;
      border-left: 1px solid #ebeff4;
      padding: 0 30px;
    }
    & .policy-right {
      & > p {
        margin: 0;
        padding-bottom: 15px;
        font-size: 14px;
        .svg-icon {
          color: #1d6cea;
          font-size: 18px;
          margin-right: 6px;
        }
      }
      & > div {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 10px;
        & small {
          padding: 8px 20px;
          background-color: rgba(29, 108, 234, 0.1);
          margin-right: 15px;
          margin-bottom: 15px;
          border-radius: 4px;
          color: #333333;
          font-size: 14px;
        }
      }
    }
  }
}
.policy-link {
  padding: 20px 0;
  .el-breadcrumb {
    font-size: 16px;
  }
}
.policyInfo {
  font-size: 16px;
  color: #2875ed;
}
.policyInfoParent {
  font-size: 16px;
  color: #464647;
}
.policy-slider {
  padding: 0 8%;
  ::v-deep {
    .content {
      padding-top: 20px;
      border-top: 1px solid rgba(210, 210, 210, 1);
      word-wrap: break-word;
      & > p {
        line-height: 28px;
        &.ql-align-center {
          text-align: center;
        }
        &.ql-align-right {
          text-align: right;
        }
      }
    }
  }
}
.policy-title-top {
  text-align: center;
  padding: 30px 0 20px 0;
  & small {
    font-size: 16px;
    color: rgba(40, 40, 40, 1);
    &:last-of-type {
      margin-left: 5%;
    }
  }
}
.header-box {
  background: rgba(243, 247, 253, 1);
  padding: 20px;
  margin-bottom: 20px;
  & > div {
    display: flex;
    & p {
      margin: 0;
      width: 0;
      flex: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 10px 0;
      display: flex;
      & span {
        font-size: 16px;
        color: rgba(34, 35, 59, 1);
      }
      & small {
        font-size: 16px;
        color: rgba(153, 153, 153, 1);
        width: 0;
        flex: 1;
      }
    }
  }
}
.file {
  text-decoration: underline;
  &:hover {
    color: #2d77fc;
  }
}
.notice {
  color: #2d77fc;
  font-size: 14px;
}
.materials-table {
  p {
    margin: 0;
  }
}
.policy-button {
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
}
.materials-view {
  padding-top: 20px;
}
.policy-text {
  white-space: normal;
}
</style>
